import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import styles from './C_PaySystems.module.css';

export default function C_PaySystems() {
  return (
    <div className={styles.wrapper}>
      <Q_Icon.MirIcon width={44} height={12} />
      <Q_Icon.MasterCardIcon width={25} height={16} />
      <Q_Icon.VisaIcon width={37} height={12} />
    </div>
  );
}
